import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { CurrentUserService } from '../services/current-user.service';

@Injectable({ providedIn: 'root' })
export class GdprAcceptedGuard implements CanActivate {
  constructor(private currentUserService: CurrentUserService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    const returnUrl = route.queryParamMap.get('returnUrl');

    return this.currentUserService.currentUser.pipe(
      take(1),
      map(result => {
        // If user is not authenticated, redirect to login
        if (!result || !result.currentUser) {
          return this.router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
        }
        
        // If user is authenticated and has already accepted DPA, redirect them away
        if (result.currentUser.acceptDpa) {
          const target = returnUrl && returnUrl !== '/gdpr-acceptance' ? returnUrl : '/';
          return this.router.createUrlTree([target]);
        }

        // If user is authenticated but hasn't accepted DPA, allow access to GDPR acceptance page
        return true;
      })
    );
  }
}